import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutLtlCommodityLookup extends Layout {
	sourceLtlCommodity: DataSource;
	tableCommodity: Table;
}
